// https://fettblog.eu/typescript-typing-catch-clauses/
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
export var errorToString = function(e) {
    var result;
    if (_instanceof(e, Error)) {
        result = e.message;
    } else if (typeof e === 'string') {
        result = e;
    } else {
        result = e.toString();
    }
    // Axios response error message
    if (e.response && e.response.data && e.response.data.message) {
        result = e.response.data.message;
    } else if (e.response && e.response.data) {
        result = e.response.data;
    }
    return result;
};
// Format is "CODE403: reason for error"
export var errorToCodeAndMessage = function(e) {
    var defaultCode = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 400;
    var message = errorToString(e);
    var code = defaultCode;
    if (message.startsWith('CODE')) {
        var codeStr = message.slice(4, 7);
        code = parseInt(codeStr, 10);
        message = message.slice(8) // colon
        ;
    }
    return {
        code: code,
        message: message
    };
};
